import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationPinSolidIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.403 12.63c0-5.21 4.3-9.43 9.6-9.43s9.6 4.22 9.6 9.43c0 5.964-6.01 13.114-8.52 15.84a1.46 1.46 0 0 1-2.165 0c-2.51-2.726-8.52-9.876-8.52-15.84zm9.6 3.37c1.765 0 3.2-1.436 3.2-3.2 0-1.766-1.435-3.2-3.2-3.2a3.203 3.203 0 0 0-3.2 3.2c0 1.764 1.435 3.2 3.2 3.2" })
});
export default SvgLocationPinSolidIcon;
